(function () {
  function format(date) {
    var fmt = new Intl.DateTimeFormat('nb-NO', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
    return fmt.format(date).replace(/\./g, '');
  }

  // Returns { day: 0-6, hour: 0-23 } for `now` in Europe/Oslo time.
  // Day matches Date#getDay (0 = Sunday, 6 = Saturday). Using Oslo time so the
  // cutoff fires consistently regardless of where the visitor is browsing from.
  function osloDayHour(now) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Oslo',
      weekday: 'short',
      hour: 'numeric',
      hour12: false
    }).formatToParts(now);
    var weekday = '';
    var hour = 0;
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type === 'weekday') weekday = parts[i].value;
      if (parts[i].type === 'hour') hour = parseInt(parts[i].value, 10) || 0;
    }
    var dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return { day: dayMap[weekday], hour: hour };
  }

  function isWeekendWindow(now) {
    var info = osloDayHour(now);
    if (info.day === 6) return true;            // Saturday all day
    if (info.day === 5 && info.hour >= 16) return true;  // Friday from 16:00
    return false;
  }

  function readInt(el, attr, fallback) {
    var v = parseInt(el.getAttribute(attr), 10);
    return isNaN(v) ? fallback : v;
  }

  // Couriers don't deliver on Sundays, so any computed date that lands on a
  // Sunday (Oslo time) should slip forward one day to Monday.
  function isSundayOslo(date) {
    var weekday = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Oslo',
      weekday: 'short'
    }).format(date);
    return weekday === 'Sun';
  }

  function skipSunday(date) {
    return isSundayOslo(date) ? new Date(date.getTime() + 86400000) : date;
  }

  function update(el) {
    var now = new Date();
    var DAY_MS = 86400000;
    var packaging, minDays, maxDays;

    if (isWeekendWindow(now) && el.hasAttribute('data-weekend-packaging')) {
      packaging = readInt(el, 'data-weekend-packaging', 2);
      minDays = readInt(el, 'data-weekend-min', 3);
      maxDays = readInt(el, 'data-weekend-max', 5);
    } else {
      packaging = readInt(el, 'data-packaging', 1);
      minDays = readInt(el, 'data-min', 3);
      maxDays = readInt(el, 'data-max', 5);
    }

    var earliest = skipSunday(new Date(now.getTime() + (packaging + minDays) * DAY_MS));
    var latest = skipSunday(new Date(now.getTime() + (packaging + maxDays) * DAY_MS));
    el.textContent = format(earliest) + ' – ' + format(latest);
  }

  function initAll(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('[data-neyl-delivery-dates]');
    for (var i = 0; i < nodes.length; i++) update(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
